import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';

import Resource from '../../../components/Resource/Resource';
import Aux from '../../../hoc/Auxiliary';
import BackDrop from '../../../components/UI/Backdrop/Backdrop';
import PopupBox from '../../../components/UI/PopupBox/PopupBox';
import Input from '../../../components/UI/Input/Input';
import Button from '../../../components/UI/Button/Button';

class ChangeResources extends Component {
    state = {
        popupOpen: true,
        resourceInput: {
            name: {
                label: 'Resource',
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Name of Resource'
                },
                value: '',
            },
            description: {
                label: 'Description',
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Description of Resource'
                },
                value: '',
            },
            image: {
                label: 'Image',
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Image of Resource'
                },
                value: ''
            },
            requiredClass: {
                label: 'Required Class',
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Required Class'
                },
                value: '',
            },
            //id: 'newResource'
        },
        resourceForm: []

    }

    componentDidMount () {
        this.initializeForm();
    }

    initializeForm = () => {
        const resourceForm = [];
        for( var key in this.props.resources ) {
            const elem = this.props.resources[ key ];
            const newElem = { ...this.state.resourceInput };
            const updatedName = { ...newElem.name };
            updatedName.value = elem.name;
            newElem.name = updatedName;
            const updatedDescription = { ...newElem.description };
            updatedDescription.value = elem.description;
            newElem.description = updatedDescription;
            const updatedImage = { ...newElem.image };
            updatedImage.value = elem.image;
            newElem.image = updatedImage;
            const updatedRequiredClass = { ...newElem.requiredClass };
            updatedRequiredClass.value = elem.requiredClass;
            newElem.requiredClass = updatedRequiredClass;
            newElem.id = elem.key;
            resourceForm.push( newElem );
        }
        const emptyForm = { ...this.state.resourceInput };
        resourceForm.push( emptyForm );
        this.setState( { resourceForm: resourceForm } );
    }

    inputChangedHandler = ( event, inputId ) => {
        const splitId = inputId.split( '_' );
        const formNumber = splitId[ 0 ];
        const formElementName = splitId[ 1 ];
        const updatedForm = [ ...this.state.resourceForm ];
        const updatedResource = { ...updatedForm[ formNumber ] };
        const updatedElement = { ...updatedResource[ formElementName ] };
        updatedElement.value = event.target.value;
        updatedForm[ formNumber ][ formElementName ] = updatedElement;
        this.setState( { resourceForm: updatedForm } );
    }

    updateResourceHandler = ( event, key, id ) => {
        event.preventDefault();
        const updatedResource = {
            description: this.state.resourceForm[ id ].description.value,
            image: this.state.resourceForm[ id ].image.value,
            name: this.state.resourceForm[ id ].name.value,
            requiredClass: this.state.resourceForm[ id ].requiredClass.value
        }
        this.props.onResourceUpdated( key, updatedResource );
        this.props.close();
    }

    removeResourceHandler = ( event, key ) => {
        event.preventDefault();
        this.props.onResourceRemoved( key );
        this.props.close();
    }

    addResource = ( event ) => {
        event.preventDefault();
        const updatedForm = [ ...this.state.resourceForm ];
        const emptyForm = { ...this.state.resourceInput };
        emptyForm.id = updatedForm[ updatedForm.length - 1 ].id + 1
        updatedForm.push( emptyForm );
        this.setState( { resourceForm: updatedForm } );
    }

    render () {
        const formElementArray = [];
        for( let key in this.state.resourceForm ) {
            const formElements = [];
            const dbKey = this.state.resourceForm[ key ].id || null;
            //delete this.state.resourceForm[ key ].id;
            for( let item in this.state.resourceForm[ key ] ) {
                formElements.push( {
                    id: key + "_" + item,
                    config: this.state.resourceForm[ key ][ item ]
                } )
            }
            const imageURL = this.state.resourceForm[ key ].image.value === '' ? undefined : this.state.resourceForm[ key ].image.value;
            formElementArray.push( {
                dbKey: dbKey,
                id: key,
                formElements: formElements,
                image: imageURL
            } );
        }
        let form = ( <Aux>
            {
                formElementArray.map( resource => {
                    return <Resource
                        key={resource.id}
                        resource={resource}
                        inputChangedHandler={this.inputChangedHandler}
                        updateResourceHandler={this.updateResourceHandler}
                        removeResourceHandler={this.removeResourceHandler} />
                } )
            }
        </Aux> );
        return (
            <Aux>
                <BackDrop
                    show={this.state.popupOpen}
                    clicked={this.props.close} />
                <PopupBox>
                    <form onSubmit={this.submitHandler}>
                        {form}
                        <Button clicked={this.addResource}>ADD RESOURCE</Button>
                        <Button clicked={this.props.close}>CLOSE</Button>
                    </form>
                </PopupBox>
            </Aux >
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onResourceUpdated: ( resourceKey, updatedResource ) => dispatch( actions.updateResources( resourceKey, updatedResource ) ),
        onResourceRemoved: ( resourceKey ) => dispatch( actions.removeResource( resourceKey ) )
    }
}

export default connect( null, mapDispatchToProps )( ChangeResources );